angular.module('unica_partner.partner_services')

.factory('PartnerEditService', function ($http, getBaseApiURL) {

	var partnerEditService = {};

	partnerEditService.update = function (partnerData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/partner/update/' + partnerData.id,
			data: partnerData
		}).then(function(result) {

			if ( result ) {
				return result.data.partner;
			}

		});
	};

	return partnerEditService;
});